export default __webpack_public_path__ + "static/AI_and_Manufacturing-a15346e87ebfc9fb62870a5c04610a47.jpg";